'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
var $d_Ljava_time_format_internal_DateTimePrinterParser = new $j_java$002elang$002e$002dObject.$TypeData().i(1, "java.time.format.internal.DateTimePrinterParser", ({
  av: 1
}));
export { $d_Ljava_time_format_internal_DateTimePrinterParser as $d_Ljava_time_format_internal_DateTimePrinterParser };
